import React from 'react';
import { useSelector } from 'react-redux';
import { dotOnlyDateWithDayName } from 'Util/DateUtils';
import icCheck1 from 'Assets/img/sidebar/ic_check_fff.png';
import icCheck2 from 'Assets/img/sidebar/ic_check_fff@2x.png';
import icCheck3 from 'Assets/img/sidebar/ic_check_fff@3x.png';
import { getImageSet } from 'Util/DataUtils';

const icCheck = getImageSet([icCheck1, icCheck2, icCheck3]);

const SelectFieldItem = ({ field, isSelected, onSelect, searchText, isStorage = false }) => {
  const { locale } = useSelector(state => state.settings.locale);

  // 정규표현식 특수문자를 이스케이프하는 함수
  const escapeRegExp = string => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };

  const highlightSearchKeyword = text => {
    if (!searchText) return text;

    const escapedSearchText = escapeRegExp(searchText);
    const parts = text.split(new RegExp(`(${escapedSearchText})`, 'gi'));
    return parts.map((part, i) => {
      if (part.toLowerCase() === searchText.toLowerCase()) {
        return (
          <span key={i} style={{ color: '#0567F9', fontWeight: 700 }}>
            {part}
          </span>
        );
      }
      return <span key={i}>{part}</span>;
    });
  };

  return (
    <div className={`field-sidebar-select-item ${isSelected ? 'selected' : ''} cursor-pointer no-drag`} onClick={onSelect}>
      <div className="field-sidebar-select-item-left">
        <div className={`field-sidebar-select-item-left-name ${isStorage ? 'storage' : ''} ${isSelected ? 'selected' : ''}`}>{highlightSearchKeyword(field.name)}</div>
        <div className={`field-sidebar-select-item-left-address ${isStorage ? 'storage' : ''} ${isSelected ? 'selected' : ''}`}>
          {highlightSearchKeyword(`${field.address || ''} ${field.address2 || ''}`)}
        </div>
        {(field.dateConstructStart || field.dateConstructEnd) && (
          <div className={`field-sidebar-select-item-left-date ${isStorage ? 'storage' : ''} ${isSelected ? 'selected' : ''}`}>{`${dotOnlyDateWithDayName(
            field.dateConstructStart,
            locale
          )} ~ ${dotOnlyDateWithDayName(field.dateConstructEnd, locale)}`}</div>
        )}
      </div>
      <div className={`field-sidebar-select-item-right-check ${isSelected ? 'selected' : ''}`}>
        <img {...icCheck} alt="check" />
      </div>
    </div>
  );
};

export default SelectFieldItem;
